import { Skeleton } from "@/components/ui/skeleton";

export default function ToolCardSkeleton() {
  return (
    <div className="block transition-shadow border border-light-grey bg-light rounded-2xl overflow-hidden h-full">
      <div className="relative float-right w-12 h-12">
        <Skeleton className="w-6 h-6 mt-4 mr-4" />
      </div>
      <div className="px-5 py-5">
        <div className="mb-16 rounded-2xl bg-secondary aspect-square max-w-14 max-h-14">
          <Skeleton className="w-full h-full rounded-2xl" />
        </div>
        <div className="self-end">
          <Skeleton className="h-6 w-32 mb-2" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-full" />
            <Skeleton className="h-4 w-4/5" />
          </div>
        </div>
      </div>
    </div>
  );
}
